import { useEffect, useState } from 'react';
import { lightTheme as adminPanelLightTheme } from '@modules/admin-panel/theme';
import { useLazyGetDomainSettingsQuery } from '@modules/shared/api/whitelabel-api';
import { domainSlice } from '@modules/shared/slices/domain-slice';
import { useAppDispatch, useAppSelector } from '@store';
import { themeSlice } from '@store/slices/theme-slice';
import { getApiBaseUrl } from '@utils/get-api-base-url';
import { getEnvVar } from '@utils/get-env-var';
import cloneDeep from 'lodash/cloneDeep';
import merge from 'lodash/merge';

import { lightTheme as dashboardLightTheme } from '../../theme';

export const useLoadDomainSettings = () => {
    const isInitialized = useAppSelector((state) => state.domain.isInitialized);
    const isLoading = useAppSelector((state) => state.domain.isLoading);
    const [isError, setIsError] = useState(false);
    const dispatch = useAppDispatch();
    const [getDomainSettings] = useLazyGetDomainSettingsQuery();

    useEffect(() => {
        const url = getApiBaseUrl();

        if (isInitialized || isLoading || url == null) {
            return;
        }

        dispatch(domainSlice.actions.setLoading(true));
        getDomainSettings({
            url,
            domain: getEnvVar('REACT_APP_PUBLIC_SETTINGS_DOMAIN'),
        })
            .unwrap()
            .then((domainSettings) => {
                if (domainSettings) {
                    dispatch(domainSlice.actions.setSettings(domainSettings));
                    if (domainSettings.ui_settings) {
                        const merged = cloneDeep(
                            domainSettings.is_admin_panel
                                ? adminPanelLightTheme
                                : dashboardLightTheme,
                        );

                        merge(merged, cloneDeep(domainSettings.ui_settings));
                        dispatch(themeSlice.actions.setTheme(merged));
                    } else {
                        dispatch(
                            themeSlice.actions.setTheme(
                                domainSettings.is_admin_panel
                                    ? adminPanelLightTheme
                                    : dashboardLightTheme,
                            ),
                        );
                    }
                    setIsError(false);
                }
            })
            .catch((err) => {
                // eslint-disable-next-line no-console
                console.error(err);
                setIsError(true);
            })
            .finally(() => {
                dispatch(domainSlice.actions.setLoading(false));
                dispatch(domainSlice.actions.setInitialized(true));
            });
    }, [dispatch, getDomainSettings, isInitialized, isLoading]);

    return { isLoadingDomainSettings: !isInitialized || isLoading, isError };
};
